'use client';

import { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { useI18n } from '@/lib/i18n';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.bevelure.app';
const ANDROID_APP_INTENT = `intent:///#Intent;scheme=bevelure;package=com.bevelure.app;S.browser_fallback_url=${encodeURIComponent(PLAY_STORE_URL)};end`;
const DISMISSED_KEY = 'bevelure-app-banner-dismissed';

export function AppInstallBanner() {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const isAndroid = /Android/i.test(navigator.userAgent);
    const wasDismissed = window.sessionStorage.getItem(DISMISSED_KEY) === 'true';
    const shouldShow = isAndroid && !wasDismissed;

    setVisible(shouldShow);
    document.documentElement.style.setProperty('--app-banner-offset', shouldShow ? '72px' : '0px');

    return () => {
      document.documentElement.style.removeProperty('--app-banner-offset');
    };
  }, []);

  const dismiss = () => {
    window.sessionStorage.setItem(DISMISSED_KEY, 'true');
    document.documentElement.style.setProperty('--app-banner-offset', '0px');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <>
      <aside
        className="fixed inset-x-0 top-0 z-[100] flex h-[72px] items-center gap-3 border-b border-[#E8DDD5] bg-white px-3 shadow-sm"
        aria-label={t('landing.appBanner.subtitle')}
      >
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src="/logo.svg" alt="" className="h-11 w-11 flex-shrink-0 rounded-xl" />
        <div className="min-w-0 flex-1">
          <p className="truncate text-base font-bold text-ink-900">Bevelure</p>
          <p className="truncate text-xs text-stone-500">{t('landing.appBanner.subtitle')}</p>
        </div>
        <a
          href={ANDROID_APP_INTENT}
          className="rounded-full bg-ink-900 px-4 py-2 text-xs font-bold text-white"
        >
          {t('landing.appBanner.action')}
        </a>
        <button
          type="button"
          onClick={dismiss}
          className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full text-stone-500 hover:bg-stone-100"
          aria-label={t('landing.appBanner.close')}
        >
          <X size={18} />
        </button>
      </aside>
      <div className="h-[72px]" aria-hidden />
    </>
  );
}
